/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/no-shadow */

'use-strict';

import { ILocationService, IScope } from 'angular';
import { RootScope } from 'app.config';
import { NgTableParams } from 'ng-table';
import { TitleService } from 'src/app/shared/services/title';
import { FuelAPIService } from '../../../shared/api/fuel-api.service';
import { InterfaceService } from '../../../shared/interface/interface.service';
import { FuelReceiptWithVehicle } from '../../../src/app/@shared-types/fuel';
import { UserRole } from '../../../src/app/@types/user';
import LogService from '../../../src/app/shared/services/log';
import { PermissionsService } from '../../authorization/permissions.service';

interface FuelTableScope extends IScope {
  table: NgTableParams<FuelReceiptWithVehicle>,
  receipts: FuelReceiptWithVehicle[] | null,
  removeAllFilter: () => void,
  removeFilter: (filter: string) => void,
  tableClick: (receiptId: number) => void,
}

/* @ngInject */
export default function FuelTableController(
  $scope: FuelTableScope,
  $location: ILocationService,
  NgTableParams: any,
  fuelApiService: FuelAPIService,
  interfaceService: InterfaceService,
  permissionsService: PermissionsService,
  logService: LogService,
): void {
  $scope.receipts = null;

  const updateTableData = () => {
    if (!$scope.receipts) return;
    $scope.table.settings({
      dataset: $scope.receipts,
    });
    interfaceService.applyScope($scope);
  };

  const getReceipts = () => {
    fuelApiService.getAll()
      .then((receipts) => {
        $scope.receipts = receipts;
        updateTableData();
      })
      .catch((e) => logService.error(e));
  };

  const init = () => {
    $scope.table = new NgTableParams({
      sorting: {
        id: 'desc',
      },
    });

    getReceipts();
  };

  /**
   * Remove all applied filters from table
   */
  $scope.removeAllFilter = () => {
    $scope.table.filter({});
  };

  /**
   * Remove the supplied filter from the view's table.
   * @param {Object} filter
   */
  $scope.removeFilter = (filter: string) => {
    delete $scope.table.filter()[filter];
  };

  $scope.tableClick = (receiptId) => {
    if (!permissionsService.isPermitted([UserRole.SELLER_PLUS])) return;

    $location.path(`/sales/fuel/edit/${receiptId}`);
  };

  init();
}
